(function(){
  if (window.__ostCartPos) return;
  window.__ostCartPos = true;

  var SECTION = 'shopify-section-cart-drawer-section';
  var OPT_OUT = 'ost:protect-off';

  function root(){
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- placement ---------- */

  function seat(){
    var summary = document.querySelector('.cart-drawer__summary');
    if (!summary) return;

    var totals = summary.querySelector('.cart-totals');
    var ctas   = summary.querySelector('.cart__ctas');

    var extras = document.querySelector('[data-ost-cart-extras]');
    if (extras && totals && totals.nextElementSibling !== extras) {
      totals.insertAdjacentElement('afterend', extras);
    }
    if (extras) extras.hidden = false;

    var below = document.querySelector('[data-ost-cart-below]');
    if (below && ctas && ctas.nextElementSibling !== below) {
      ctas.insertAdjacentElement('afterend', below);
    }
    if (below) below.hidden = false;
  }

  var queued = false;
  function schedule(){
    if (queued) return;
    queued = true;
    requestAnimationFrame(function(){ queued = false; seat(); autoProtect(); });
  }

  /* ---------- in-place refresh ----------
     The original refresh replaced the whole section's innerHTML, which throws
     away the <dialog> the drawer is currently showing — so the cart snapped
     shut every time the protection toggle fired. This swaps only the regions
     whose contents actually changed and never touches the dialog itself. */

  var SWAP = ['.cart-drawer__items', '.cart-totals', '.cart-drawer__heading', '.theme-drawer__title'];

  function updateBubble(count){
    document.querySelectorAll('.cart-bubble').forEach(function(b){
      if (count > 0) b.classList.remove('visually-hidden');
    });
    document.querySelectorAll('.cart-bubble__text-count').forEach(function(c){
      c.textContent = count;
      if (count > 0) c.classList.remove('hidden');
    });
    var live = document.querySelector('[data-testid="cart-count-live-region"]');
    if (live) live.textContent = count;
  }

  function refreshInPlace(){
    var host = document.getElementById(SECTION);
    if (!host) return Promise.resolve();
    return fetch(root() + '?sections=cart-drawer-section', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        if (!data || !data['cart-drawer-section']) return;
        var doc = new DOMParser().parseFromString(data['cart-drawer-section'], 'text/html');

        SWAP.forEach(function(sel){
          var fresh = doc.querySelector(sel);
          var live  = host.querySelector(sel);
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        });

        ['[data-ost-cart-extras]', '[data-ost-cart-below]'].forEach(function(sel){
          var fresh = doc.querySelector(sel);
          var live  = document.querySelector(sel);
          if (!fresh) return;
          if (live) { live.innerHTML = fresh.innerHTML; }
          else { host.appendChild(fresh.cloneNode(true)); }
        });

        schedule();
      })
      .catch(function(){});
  }

  /* ---------- shipping protection toggle ----------
     Capture phase + stopPropagation, so ostner-home.js's own delegated
     handler — the one that does the drawer-destroying refresh — never
     receives the event. */

  function handleProtect(cb){
    var id = Number(cb.getAttribute('data-variant'));
    var wanted = cb.checked;
    cb.disabled = true;

    var req = wanted
      ? fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
      : fetch(root() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(id), quantity: 0 })
        });

    req.then(function(r){ if (!r.ok) throw new Error('cart'); })
      .then(function(){
        return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(c){ if (c) updateBubble(c.item_count); });
      })
      .then(refreshInPlace)
      .then(function(){
        var fresh = document.querySelector('[data-ost-protect]');
        if (fresh) { fresh.checked = wanted; fresh.disabled = false; }
      })
      .catch(function(){
        cb.checked = !wanted;
        cb.disabled = false;
      });
  }

  document.addEventListener('change', function(e){
    var cb = e.target && e.target.closest ? e.target.closest('[data-ost-protect]') : null;
    if (!cb) return;
    e.stopPropagation();
    // Remember an explicit opt-out so the default-on rule below never
    // re-adds it behind the shopper's back.
    try {
      if (cb.checked) sessionStorage.removeItem(OPT_OUT);
      else sessionStorage.setItem(OPT_OUT, '1');
    } catch (err) {}
    handleProtect(cb);
  }, true);

  /* ---------- protection on by default ----------
     Adds the line item once per visit when the drawer first renders with real
     items in it, unless the shopper has already switched it off. */

  var adding = false;

  function autoProtect(){
    if (adding) return;
    var host = document.querySelector('[data-ost-cart-extras][data-ost-protect-default]');
    if (!host) return;
    var cb = host.querySelector('[data-ost-protect]');
    if (!cb || cb.checked) return;
    try { if (sessionStorage.getItem(OPT_OUT)) return; } catch (err) {}

    adding = true;
    cb.checked = true;
    handleProtect(cb);
    setTimeout(function(){ adding = false; }, 1200);
  }

  /* ---------- boot ---------- */

  function watch(){
    var host = document.getElementById(SECTION);
    if (!host || host.__ostSeated) return;
    host.__ostSeated = true;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    schedule();
  }

  function boot(){ watch(); schedule(); setTimeout(autoProtect, 250); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('click', function(e){
    if (e.target && e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"]')) {
      setTimeout(schedule, 80);
    }
  });
})();
